import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ModalBtn from '../../molecules/modalButton/view';
import { AiFillBackward } from 'react-icons/ai';
import { ArrowBack, ArrowForward, AssignmentReturn, BackHand, KeyboardReturn } from '@mui/icons-material';
import ButtonSecondary from '../../atoms/ButtonSecondary/view';

// Assuming a basic Modal component exists or will be created
// For now, I'll use a placeholder div for the modal structure
// import Modal from '../atoms/modal'; // Example import

const DynamicProgressModal = ({ steps, onClose, onFinish, currentStepIndex, onStepChange, hiddenBar = false, hiddenPrev = false, hiddenTitle = false }) => {

  const [stepData, setStepData] = useState({});

  const currentStep = steps[currentStepIndex];

  const handleNext = () => {
    // TODO: Add validation for the current step before proceeding
    if (currentStepIndex < steps.length - 1) {
      onStepChange(currentStepIndex + 1); // Use onStepChange to update parent's state
    } else {
      // This is the last step, call onFinish
      onFinish(stepData);
    }
  };

  const handlePrevious = () => {
    if (currentStepIndex > 0) {
      onStepChange(currentStepIndex - 1); // Use onStepChange to update parent's state
    }
  };

  const handleStepDataChange = (data) => {
    setStepData((prevData) => ({
      ...prevData,
      [currentStepIndex]: data, // Store data keyed by step index
    }));
  };

  // Render the component for the current step, passing down data and a handler to update it
  const renderStepContent = () => {
    if (!currentStep || !currentStep.component) {
      return <div>No step content available</div>;
    }

    const props = {
      ...currentStep.props,
      currentStepData: stepData[currentStepIndex] || {},
      onDataChange: handleStepDataChange
    };

    if (typeof currentStep.component === 'function') {
      return currentStep.component(props);
    }

    const StepComponent = currentStep.component;
    return <StepComponent {...props} />;
  };

  return (
    <div>
      {/* Modal Header */}
      {!hiddenTitle && (
        <div>
          <h2>{currentStep?.title || `Step ${currentStepIndex + 1}`}</h2>
        </div>
      )}

      <div hidden={hiddenBar} style={{ marginBottom: '10px' }}>
        <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '5px', overflow: 'hidden' }}>
          <div style={{
            width: `${(currentStepIndex + 1) / steps.length * 100}%`,
            height: '20px',
            backgroundColor: '#4CAF50', // Green color for progress
            borderRadius: '5px',
            textAlign: 'center',
            lineHeight: '20px',
            color: 'white',
            transition: 'width 0.3s ease-in-out'
          }} />
        </div>
      </div>

      {/* Modal Footer - Navigation */}
      <div hidden={hiddenPrev} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {currentStepIndex > 0 && (
          <ButtonSecondary
            onClick={handlePrevious}
            disabled={currentStepIndex === 0}
            icon={<ArrowBack style={{ marginRight: '4px', fontSize: '1.2rem' }} />}
            title="Volver"
          />
        )}
        {currentStep.showContinueButton && (
          <ButtonSecondary
            onClick={handleNext}
            title={currentStepIndex === steps.length - 1 ? 'Finalizar' : 'Continuar'}
            icon={currentStepIndex === steps.length - 1 ? undefined : <ArrowForward style={{ marginRight: '4px', fontSize: '1.2rem' }} />}
            style={{ marginLeft: 'auto' }}
          />
        )}
      </div>

      {/* Modal Body - Render the current step's component */}
      <div style={{ marginBottom: '20px', padding: '20px' }}>
        {renderStepContent()}
      </div>
    </div>
  );
};

DynamicProgressModal.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      component: PropTypes.elementType.isRequired,
      showContinueButton: PropTypes.bool, // Optional prop to control visibility of continue button
      props: PropTypes.object, // Optional props for the step component
      // validation: PropTypes.func, // Optional validation function for the step
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  currentStepIndex: PropTypes.number.isRequired, // New prop
  onStepChange: PropTypes.func.isRequired, // New prop
  showContinueButton: PropTypes.bool, // Controls visibility of the continue button
  onContinue: PropTypes.func, // Handler for the continue button click
};

export default DynamicProgressModal;
